import { ColumnDef } from '@tanstack/react-table';
import { isAfter, isBefore } from 'date-fns';
import { LOYALTY_ACTIVITY_DEFINITION_TYPE_DICT } from 'pages/LoyaltyActivityDefinitions/Form/constants';
import { datePrettier } from 'utils/date';

function GetColumns(): ColumnDef<LoyaltyActivityDefinition, string>[] {
  return [
    {
      header: 'Nazwa',
      accessorKey: 'name',
      cell: (info) => info.getValue(),
    },
    {
      header: 'Typ',
      accessorKey: 'type',
      cell: (info) => LOYALTY_ACTIVITY_DEFINITION_TYPE_DICT[info.getValue()],
    },
    {
      header: 'Data utworzenia',
      accessorKey: 'createdAt',
      cell: (info) => datePrettier(info.getValue()),
    },
    {
      header: 'Data ważności',
      accessorKey: 'activeTo',
      cell: (info) => datePrettier(info.getValue()),
    },
    {
      header: 'Status',
      accessorKey: 'status',
      cell: ({
        row: {
          original: { activeFrom, activeTo },
        },
      }) =>
        isAfter(new Date(), new Date(activeFrom)) &&
        isBefore(new Date(), new Date(activeTo))
          ? 'Aktywna'
          : 'Nieaktywna',
    },
    {
      header: 'Akcje',
      accessorKey: 'action',
    },
  ];
}

export default GetColumns;
